import * as React from "react";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { SubNavigation, IMenuItem } from "../SubNavigation";
import { ListIcon } from '../../atoms/icons/ListIcon';
import AddIcon from '@material-ui/icons/Add';
import { Dispatch } from "redux";
import { RootActionCreators } from "../../../store";
import { useTranslation } from 'react-i18next';

// CSS
const useStyles = makeStyles((theme) => ({ }));

export enum ClientNavigationPage {
    List = "List",
    Details = "Details",
    Edit = "Edit",
    New = "New"
}

interface ICoolMenuItem extends IMenuItem {
    page: ClientNavigationPage;
}

// All the incoming values
interface IProps {
    selected?: ClientNavigationPage;
    children?: React.ReactNode;
}

// All Navigation Functions
export interface INavigations {
    onClickList: () => void;
    onClickNew: () => void;
}
export const mapNavigationsToProps = (dispatch: Dispatch): INavigations => ({
    onClickList: () => dispatch(RootActionCreators.Navigate.ToClientList()),
    onClickNew: () => dispatch(RootActionCreators.Navigate.ToClientNew()),
});

// Outgoing functions
interface IDispatch {
    navigations: INavigations
}

// Actual Component
export type AllProps = IProps & IDispatch;
export const ClientNavigation = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tCommon } = useTranslation('common');

    const pages: ICoolMenuItem[] = [
        {
            label: tCommon('list'),
            icon: <ListIcon />,
            page: ClientNavigationPage.List,
            onClick: props.navigations.onClickList
        },
        {
            label: tCommon('add'),
            icon: <AddIcon />,
            page: ClientNavigationPage.New,
            onClick: props.navigations.onClickNew
        }
    ];

    // If the selected page is in the pages array, use that index, otherwise don't select any
    const selectedIndex = props.selected ? pages.findIndex(item => item.page === props.selected) : 0;
    
    // Remove the error throw and just use -1 (no selection) if the page isn't found
    // This handles cases when we're on Edit or Details page
    
    return (<SubNavigation menuItems={pages} selectedIndex={selectedIndex}>{props.children}</SubNavigation>)
};

